var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisibilityFill = function SvgVisibilityFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16q1.875 0 3.188-1.312Q16.5 13.375 16.5 11.5t-1.312-3.187T12 7 8.813 8.313 7.5 11.5t1.313 3.188T12 16m0-1.8q-1.125 0-1.912-.787A2.6 2.6 0 0 1 9.3 11.5q0-1.125.787-1.912A2.6 2.6 0 0 1 12 8.8q1.125 0 1.912.787.788.788.788 1.913t-.787 1.912A2.6 2.6 0 0 1 12 14.2m0 4.8q-3.35 0-6.112-1.8t-4.363-4.75a1.907 1.907 0 0 1-.187-1.437q.062-.238.187-.463 1.6-2.95 4.363-4.75Q8.65 4 12 4t6.113 1.8 4.362 4.75q.125.225.188.462a1.9 1.9 0 0 1 0 .976 2 2 0 0 1-.188.462q-1.6 2.95-4.363 4.75Q15.35 19 12 19"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisibilityFill);
export { ForwardRef as ReactComponent };